import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'localizeddate',
    pure: false,
    standalone: false
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(protected translate: TranslateService) { }

  transform(value: any, format: string = 'mediumDate'): any {
    let locale = this.translate.getCurrentLang();
    if (locale.startsWith('sv') || locale.startsWith('se'))
      locale = 'se-SE';
    else if (locale.startsWith('ar') || locale.startsWith('en'))
      locale = 'en-GB';
    else if (locale.startsWith('pl'))
      locale = 'pl-PL';
    else if (locale.startsWith('de'))
      locale = 'de-DE';

    if (typeof value === 'string' && value.includes('T') && !value.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(value))
      value = value + 'Z';

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const datePipe: DatePipe = new DatePipe(locale);
    return datePipe.transform(value, format, timezone);
  }
}
